import "./Products.module.css";
import Header from "@/reusable_sections/Header";
import OurProducts from "./sections/OurProducts";
import PrecisionPerformance from "./sections/PrecisionPerformance";
import OurPavingLandscapingExpertise from "./sections/OurPavingLandscapingExpertise";
import ClientCarouselFooter from "./sections/ClientCarouselFooter";
import Footer from "@/reusable_sections/Footer";
export default function ProductsPage() {
  return <div>
      <Header />
      <OurProducts />
      <PrecisionPerformance />
      <OurPavingLandscapingExpertise />
      <ClientCarouselFooter />
      <Footer />
    </div>;
}